"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[393],{

/***/ 83910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LatestMatches_LatestMatches; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./src/components/shared/PlayerAvatar/index.ts + 1 modules
var PlayerAvatar = __webpack_require__(81228);
// EXTERNAL MODULE: ./src/components/shared/PlayerName/index.ts + 1 modules
var PlayerName = __webpack_require__(72869);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(7809);
;// CONCATENATED MODULE: ./src/lib/canDeleteMatch.ts

const differenceInDays = (date1, date2)=>{
    const diff = Math.abs(date2.getTime() - date1.getTime());
    return diff / (1000 * 3600 * 24);
};
const canDeleteMatch = (param)=>{
    let { user , players , createdAt  } = param;
    if (!(user === null || user === void 0 ? void 0 : user.id)) return false;
    if ((user === null || user === void 0 ? void 0 : user.roleId) === 0) return true;
    if (differenceInDays(new Date(), new Date(createdAt)) > constants/* MATCH_DELETE_DAYS */.O3) return false;
    return !!players.find((player)=>player.id === user.id);
};
/* harmony default export */ var lib_canDeleteMatch = (canDeleteMatch);

;// CONCATENATED MODULE: ./src/lib/points.ts
const getPointsToMove = (param)=>{
    let { matchPoints , leftLength , rightLength  } = param;
    return Math.ceil(matchPoints * Math.max(leftLength, rightLength));
};
const getPlayerPointsToMove = (param)=>{
    let { pointsToMove , teamLength  } = param;
    return Math.ceil(pointsToMove / teamLength);
};

// EXTERNAL MODULE: ./src/lib/utils/formatDateTime.ts
var formatDateTime = __webpack_require__(3277);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/v-stack.mjs
var v_stack = __webpack_require__(10461);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(542);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-auth@4.24.11_next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@1_acaee22c3ffd625475c47b7b2c959a5f/node_modules/next-auth/react/index.js
var react = __webpack_require__(25096);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var node_modules_react = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+hooks@2.4.5_react@18.3.1/node_modules/@chakra-ui/hooks/dist/esm/use-disclosure.mjs
var use_disclosure = __webpack_require__(46175);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/toast/use-toast.mjs + 2 modules
var use_toast = __webpack_require__(52889);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover.mjs + 2 modules
var popover = __webpack_require__(25217);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-trigger.mjs
var popover_trigger = __webpack_require__(37973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/close-button/close-button.mjs
var close_button = __webpack_require__(67073);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/portal/portal.mjs
var portal = __webpack_require__(796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-content.mjs + 1 modules
var popover_content = __webpack_require__(63651);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-arrow.mjs
var popover_arrow = __webpack_require__(61521);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-body.mjs
var popover_body = __webpack_require__(35401);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/popover/popover-footer.mjs
var popover_footer = __webpack_require__(92142);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 4 modules
var button_button = __webpack_require__(96756);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@0.25.0/node_modules/axios/index.js
var axios = __webpack_require__(72698);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/components/shared/Toast/index.ts + 1 modules
var Toast = __webpack_require__(73706);
;// CONCATENATED MODULE: ./src/components/shared/LatestMatches/MatchSummary/DeleteButton.tsx






const DeleteMatchButton = (_param)=>{
    var { id , seasonId , onDeleteStart , onDeleteSuccess , onDeleteError  } = _param, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "seasonId",
        "onDeleteStart",
        "onDeleteSuccess",
        "onDeleteError"
    ]);
    const { isOpen , onToggle , onClose  } = (0,use_disclosure/* useDisclosure */.q)();
    const toast = (0,use_toast/* useToast */.p)();
    const handleClick = async ()=>{
        onDeleteStart === null || onDeleteStart === void 0 ? void 0 : onDeleteStart();
        try {
            await axios_default()["delete"]("/api/matches?matchId=".concat(id, "&seasonId=").concat(seasonId));
            toast({
                render: ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* default */.Z, {
                        status: "success",
                        heading: "It’s gone",
                        content: "Match deleted successfully."
                    }),
                position: "bottom"
            });
            onDeleteSuccess === null || onDeleteSuccess === void 0 ? void 0 : onDeleteSuccess();
        } catch (e) {
            toast({
                render: ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* default */.Z, {
                        status: "error",
                        heading: "Oh no!",
                        content: "Could not delete match."
                    }),
                position: "bottom"
            });
            onDeleteError === null || onDeleteError === void 0 ? void 0 : onDeleteError();
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(popover/* Popover */.J, {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover_trigger/* PopoverTrigger */.x, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(close_button/* CloseButton */.P, (0,_object_spread/* default */.Z)({
                    "aria-label": "Erase match",
                    position: "absolute",
                    size: "sm",
                    right: "0",
                    top: "0",
                    transform: "translate(25%, -25%)",
                    bg: "grey.6",
                    _hover: {
                        bg: "danger.9",
                        color: "grey.1"
                    },
                    borderRadius: "full",
                    onClick: onToggle
                }, props))
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal/* Portal */.h, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(popover_content/* PopoverContent */.y, {
                    mx: 4,
                    zIndex: "popover",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover_arrow/* PopoverArrow */.Q, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(popover_body/* PopoverBody */.b, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                    fontWeight: "bold",
                                    children: "Are you sure?"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                    color: "grey.10",
                                    children: "Deleting the match will revert the points moved."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                            as: popover_footer/* PopoverFooter */.D,
                            p: 0,
                            spacing: 0,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                                    borderRadius: 0,
                                    borderBottomLeftRadius: "lg",
                                    flex: 1,
                                    variant: "solid",
                                    colorScheme: "danger",
                                    onClick: ()=>{
                                        handleClick();
                                        onClose();
                                    },
                                    children: "Delete"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                                    borderRadius: 0,
                                    borderBottomRightRadius: "lg",
                                    flex: 1,
                                    variant: "subtle",
                                    colorScheme: "grey",
                                    top: 0,
                                    left: 0,
                                    onClick: onClose,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var DeleteButton = (DeleteMatchButton);

// EXTERNAL MODULE: ./src/components/shared/PointIcon/index.ts + 1 modules
var PointIcon = __webpack_require__(60135);
;// CONCATENATED MODULE: ./src/components/shared/LatestMatches/MatchSummary/ScoreTrend.tsx



const ScoreTrend = (param)=>{
    let { score , isPositive  } = param;
    if (!score) return null;
    const color = isPositive ? "success.9" : "danger.9";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
        fontSize: "xs",
        fontWeight: "bold",
        spacing: 1,
        color: {
            base: color,
            md: "grey.8"
        },
        _groupHover: {
            color
        },
        transition: ".3s ease-out",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography_text/* Text */.x, {
                children: [
                    isPositive ? "+" : "–",
                    score
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointIcon/* default */.Z, {
                bg: "currentColor"
            })
        ]
    });
};
/* harmony default export */ var MatchSummary_ScoreTrend = (ScoreTrend);

;// CONCATENATED MODULE: ./src/components/shared/LatestMatches/MatchSummary/MatchSummary.tsx











const WinnerIcon = ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
        fontSize: "md",
        as: "span",
        children: "\uD83C\uDFC6"
    });
const MatchSummary = (param)=>{
    let { id , seasonId , createdAt , leftscore , rightscore , left , right , gameName , officeName , onDelete , points ,  } = param;
    const { data: session  } = (0,react.useSession)();
    const { 0: isLoading , 1: setIsLoading  } = (0,node_modules_react.useState)(false);
    const canDelete = onDelete && lib_canDeleteMatch({
        user: session === null || session === void 0 ? void 0 : session.user,
        createdAt,
        players: [
            ...left,
            ...right
        ]
    });
    const pointsToMove = points ? getPointsToMove({
        leftLength: left.length,
        rightLength: right.length,
        matchPoints: points
    }) : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(v_stack/* VStack */.g, {
        role: "group",
        opacity: isLoading ? 0.2 : 1,
        transition: "opacity .2s ease-out",
        spacing: "0",
        bg: "grey.1",
        borderRadius: 16,
        px: 2,
        position: "relative",
        boxShadow: "0px 0px 0 1px var(--wrkplay-colors-grey-4)",
        _hover: {
            boxShadow: "0px 0px 0 1px var(--wrkplay-colors-grey-6)"
        },
        children: [
            canDelete && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteButton, {
                zIndex: 2,
                id: id,
                seasonId: seasonId,
                onDeleteStart: ()=>setIsLoading(true),
                onDeleteError: ()=>setIsLoading(false),
                onDeleteSuccess: ()=>onDelete()
            }),
            createdAt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                color: "grey.11",
                textAlign: "center",
                bg: "grey.1",
                border: "1px",
                borderColor: "grey.4",
                px: 4,
                py: 1,
                borderRadius: "full",
                position: "absolute",
                top: "0",
                transform: "translateY(-50%)",
                fontSize: "xs",
                letterSpacing: "wide",
                noOfLines: 1,
                maxW: "80%",
                fontWeight: "medium",
                _groupHover: {
                    borderColor: "grey.6"
                },
                children: [
                    (0,formatDateTime/* formatDateTime */.o)(new Date(createdAt)),
                    " ",
                    officeName && "at ".concat(officeName)
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                px: 4,
                py: 6,
                w: "100%",
                justifyContent: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v_stack/* VStack */.g, {
                        flex: 1,
                        lineHeight: 1.2,
                        spacing: 8,
                        children: left.map((player)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(v_stack/* VStack */.g, {
                                spacing: 1.5,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerAvatar/* default */.Z, {
                                        user: player,
                                        isLink: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerName/* default */.Z, {
                                        lineHeight: 1.2,
                                        textAlign: "center",
                                        fontSize: "sm",
                                        user: player,
                                        maxW: "30ch",
                                        noOfLines: 2,
                                        surnameType: "initial",
                                        isLink: true
                                    }),
                                    !!pointsToMove && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MatchSummary_ScoreTrend, {
                                        isPositive: leftscore > rightscore,
                                        score: getPlayerPointsToMove({
                                            pointsToMove,
                                            teamLength: left.length
                                        })
                                    })
                                ]
                            }, player.id))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                                justify: "center",
                                fontSize: "xl",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                                        flex: 1,
                                        justify: "flex-end",
                                        children: [
                                            leftscore > rightscore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WinnerIcon, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                                children: leftscore
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                        fontSize: "sm",
                                        color: "grey.9",
                                        children: "✕"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                                        flex: 1,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                                children: rightscore
                                            }),
                                            rightscore > leftscore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WinnerIcon, {})
                                        ]
                                    })
                                ]
                            }),
                            gameName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                                textAlign: "center",
                                textTransform: "uppercase",
                                fontSize: "xs",
                                color: "grey.9",
                                letterSpacing: "wider",
                                children: gameName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(v_stack/* VStack */.g, {
                        flex: 1,
                        lineHeight: 1.2,
                        spacing: 8,
                        children: right.map((player)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(v_stack/* VStack */.g, {
                                spacing: 1.5,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerAvatar/* default */.Z, {
                                        user: player,
                                        isLink: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerName/* default */.Z, {
                                        lineHeight: 1.2,
                                        textAlign: "center",
                                        fontSize: "sm",
                                        user: player,
                                        maxW: "30ch",
                                        noOfLines: 2,
                                        surnameType: "initial",
                                        isLink: true
                                    }),
                                    !!pointsToMove && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MatchSummary_ScoreTrend, {
                                        isPositive: leftscore < rightscore,
                                        score: getPlayerPointsToMove({
                                            pointsToMove,
                                            teamLength: right.length
                                        })
                                    })
                                ]
                            }, player.id))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MatchSummary_MatchSummary = (MatchSummary);

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(80883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(75616);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(3276);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(63997);
// EXTERNAL MODULE: ./src/components/shared/Skeleton/index.ts + 1 modules
var Skeleton = __webpack_require__(73780);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(21617);
;// CONCATENATED MODULE: ./src/components/shared/LatestMatches/useLatestMatches.tsx


const useLatestMatches = (options)=>{
    const queryKey = (0,node_modules_react.useMemo)(()=>{
        return [
            "matches",
            options
        ];
    }, [
        options
    ]);
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)(queryKey, async (param)=>{
        let { pageParam  } = param;
        const searchParams = new URLSearchParams(JSON.parse(JSON.stringify(options)));
        pageParam && searchParams.set("after", pageParam);
        const res = await fetch([
            "/api/matches",
            searchParams.toString()
        ].join("?")).then((res)=>res.json());
        return res;
    }, {
        getNextPageParam: (lastPage)=>{
            var ref;
            return lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.pageInfo) === null || ref === void 0 ? void 0 : ref.nextCursor;
        }
    });
};
/* harmony default export */ var LatestMatches_useLatestMatches = (useLatestMatches);

;// CONCATENATED MODULE: ./src/components/shared/LatestMatches/LatestMatches.tsx









const MotionBox = (0,motion/* motion */.E)(box/* Box */.x);
const LatestMatches = (param)=>{
    let { gameId , seasonId , userId , officeId , canLoadMore =true , canDelete =true ,  } = param;
    var ref;
    const { data , fetchNextPage , hasNextPage , isError , isLoading  } = LatestMatches_useLatestMatches({
        gameId,
        seasonId,
        userId,
        officeId
    });
    const loadMoreRef = (0,node_modules_react.useRef)(null);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const refetch = ()=>{
        queryClient.invalidateQueries([
            "matches",
            {
                gameId,
                seasonId,
                userId,
                officeId
            }
        ]);
        queryClient.invalidateQueries([
            "leaderboard",
            {
                gameId,
                seasonId
            }
        ]);
    };
    (0,node_modules_react.useEffect)(()=>{
        const options = {
            root: null,
            rootMargin: "500px",
            threshold: 1
        };
        const handleObserver = (entities)=>{
            const target = entities[0];
            if (target.isIntersecting) {
                fetchNextPage();
            }
        };
        const observer = new IntersectionObserver(handleObserver, options);
        if (hasNextPage && canLoadMore && loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }
        return ()=>observer.disconnect();
    }, [
        canLoadMore,
        hasNextPage,
        fetchNextPage
    ]);
    if (isError || (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.some((page)=>page.status === "error"))) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
            p: 4,
            textAlign: "center",
            bg: "red.100",
            borderRadius: "xl",
            color: "red.600",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                    mb: 2,
                    children: "Error loading matches :("
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                    isLoading: isLoading,
                    onClick: refetch,
                    children: "Retry"
                })
            ]
        });
    }
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(stack/* Stack */.K, {
        children: new Array(constants/* PAGE_SIZE */.IV).fill(0).map((_, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                w: "100%",
                h: "6rem",
                borderRadius: "xl"
            }, i))
    });
    const allMatches = data.pages.flatMap((page)=>{
        var ref;
        return (ref = page.data) === null || ref === void 0 ? void 0 : ref.matches;
    });
    if (allMatches.length === 0) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
        textAlign: "center",
        color: "grey.10",
        py: 8,
        children: "No matches yet!"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(stack/* Stack */.K, {
        gap: 3,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnimatePresence/* AnimatePresence */.M, {
            initial: false,
            children: [
                allMatches === null || allMatches === void 0 ? void 0 : allMatches.map((match)=>{
                    var ref, ref1, ref2;
                    if (!match) return null;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MotionBox, {
                        layout: true,
                        transition: {
                            duration: 0.3
                        },
                        initial: {
                            scale: 0.5,
                            opacity: 0
                        },
                        animate: {
                            scale: 1,
                            opacity: 1
                        },
                        exit: {
                            scale: 0.5,
                            opacity: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MatchSummary_MatchSummary, {
                            id: match.id,
                            createdAt: match.createdAt,
                            leftscore: match.leftscore,
                            left: match.left,
                            rightscore: match.rightscore,
                            right: match.right,
                            gameName: match === null || match === void 0 ? void 0 : (ref = match.game) === null || ref === void 0 ? void 0 : ref.name,
                            officeName: match === null || match === void 0 ? void 0 : (ref1 = match.game) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.office) === null || ref2 === void 0 ? void 0 : ref2.name,
                            onDelete: canDelete ? refetch : undefined,
                            points: match.points,
                            seasonId: match.seasonid
                        })
                    }, match.id);
                }),
                hasNextPage && canLoadMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                    ref: loadMoreRef,
                    isLoading: isLoading,
                    variant: "subtle",
                    colorScheme: "grey",
                    onClick: ()=>fetchNextPage(),
                    children: "Load more"
                }, "loadMore")
            ]
        })
    }, gameId);
};
/* harmony default export */ var LatestMatches_LatestMatches = (LatestMatches);

;// CONCATENATED MODULE: ./src/components/shared/LatestMatches/index.ts



/***/ }),

/***/ 72869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PlayerName_PlayerName; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./src/lib/players.ts
var players = __webpack_require__(38240);
// EXTERNAL MODULE: ./src/lib/roles.ts
var roles = __webpack_require__(42780);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(55521);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/shared/PlayerName/PlayerName.tsx








const PlayerName = (_param)=>{
    var { user , surnameType , isLink  } = _param, props = (0,_object_without_properties/* default */.Z)(_param, [
        "user",
        "surnameType",
        "isLink"
    ]);
    const isUserRemoved = (0,roles/* isRemoved */.Io)(user.roleId);
    const displayName = isUserRemoved ? "Anonymous" : (0,players/* getPlayerName */.W)(user.name, surnameType);
    const name = [
        roles/* roleIcons */.MD[user.roleId],
        displayName
    ].join(" ");
    if (!user.id || !isLink || isUserRemoved) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,roles/* getRoleStyles */.EY)(user.roleId)), {
        as: "span"
    }), props), {
        children: name
    }));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/player/".concat(user.id),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,roles/* getRoleStyles */.EY)(user.roleId)), {
            as: "a"
        }), props), {
            children: name
        }))
    });
};
/* harmony default export */ var PlayerName_PlayerName = (PlayerName);

;// CONCATENATED MODULE: ./src/components/shared/PlayerName/index.ts



/***/ }),

/***/ 60135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PointIcon_PointIcon; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./src/lib/styleUtils.ts
var styleUtils = __webpack_require__(25198);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
;// CONCATENATED MODULE: ./src/components/shared/PointIcon/PointIcon.tsx




const PointIcon = (props)=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, (0,_object_spread/* default */.Z)({
        w: ".75em",
        h: ".75em",
        bg: styleUtils/* gradientProps */.K3,
        display: "inline-block",
        borderRadius: "25%",
        transform: "rotate(-45deg)"
    }, props));
};
/* harmony default export */ var PointIcon_PointIcon = (PointIcon);

;// CONCATENATED MODULE: ./src/components/shared/PointIcon/index.ts



/***/ }),

/***/ 10923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/head.js
var head = __webpack_require__(55566);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var router = __webpack_require__(30590);
;// CONCATENATED MODULE: ./src/components/shared/SEO/SEO.tsx
/* provided dependency */ var process = __webpack_require__(87943);



const TERMS = {
    title: "workplay",
    baseURL: process.env.VERCEL_URL
};
const SEO = (param)=>{
    let { title , desc , type , imageUrl  } = param;
    const { asPath  } = (0,router.useRouter)();
    const tabInfo = {
        title: title ? "".concat(title, " ⁄ ").concat(TERMS.title) : TERMS.title,
        desc: desc ? desc : TERMS.title
    };
    const seoImage = imageUrl || "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: tabInfo.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: tabInfo.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: tabInfo.desc
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: tabInfo.desc
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: "".concat(TERMS.baseURL).concat(asPath)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: "".concat(TERMS.baseURL).concat(asPath)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: seoImage
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type || "website"
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);

;// CONCATENATED MODULE: ./src/components/shared/SEO/index.ts



/***/ }),

/***/ 73780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(79277);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.14.0_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@types+react@18.0.21_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(26091);
;// CONCATENATED MODULE: ./src/components/shared/Skeleton/Skeleton.ts



const fade = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("from{opacity:1;}to{opacity:0.1;}", "fade");
const Skeleton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(box/* Box */.x, {
    target: "ekmbdyj0",
    label: "Skeleton"
})("border-radius:var(--chakra-radii-sm);background:var(--chakra-colors-grey-7);animation:0.8s linear infinite alternate ", fade, ";");
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);

;// CONCATENATED MODULE: ./src/components/shared/Skeleton/index.ts



/***/ }),

/***/ 73706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Toast_Toast; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./src/theme/palettes.ts
var palettes = __webpack_require__(27922);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/media-query/media-query.hook.mjs + 1 modules
var media_query_hook = __webpack_require__(24858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(80883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
;// CONCATENATED MODULE: ./src/components/shared/Toast/Toast.tsx



const toastStyles = {
    error: {
        color: (0,palettes/* default */.Z)("4"),
        bg: {
            light: "grey.1",
            dark: "danger.12"
        },
        shadow: {
            light: "0px 0px 32px rgba(254, 142, 180, 0.3), 0px 8px 16px rgba(254, 142, 180, 0.4), 0px 4px 9px rgba(0, 0, 0, 0.1)",
            dark: "0 0 1px .5px var(--wrkplay-colors-danger-11)"
        }
    },
    success: {
        color: (0,palettes/* default */.Z)("1"),
        bg: {
            light: "grey.1",
            dark: "success.12"
        },
        shadow: {
            light: "0px 0px 32px rgba(96, 211, 205, 0.3), 0px 8px 16px rgba(96, 211, 205, 0.4), 0px 4px 9px rgba(0, 0, 0, 0.1)",
            dark: "0 0 1px .5px var(--wrkplay-colors-success-11)"
        }
    },
    info: {
        color: "grey.12",
        bg: {
            light: "grey.1",
            dark: "grey.12"
        },
        shadow: {
            light: "0px 0px 32px rgba(126, 128, 134, 0.1), 0px 8px 16px rgba(126, 128, 134, 0.1), 0px 4px 9px rgba(0, 0, 0, 0.1)",
            dark: "0 0 1px .5px var(--wrkplay-colors-grey-11)"
        }
    }
};
const Toast = (param)=>{
    let { status , content , heading  } = param;
    const mode = (0,media_query_hook/* useColorModePreference */.J)() || "dark";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(stack/* Stack */.K, {
        "data-testid": "toast",
        role: "alert",
        spacing: 2,
        bg: toastStyles[status].bg[mode],
        padding: "16px",
        boxShadow: toastStyles[status].shadow[mode],
        borderRadius: "xl",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                fontWeight: "bold",
                bg: toastStyles[status].color,
                backgroundClip: "text",
                children: heading
            }),
            content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                color: "grey.11",
                children: content
            })
        ]
    });
};
/* harmony default export */ var Toast_Toast = (Toast);

;// CONCATENATED MODULE: ./src/components/shared/Toast/index.ts



/***/ }),

/***/ 25094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93597);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30590);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75271);
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84943);




const useNavigationState = (title)=>{
    const [, setLastState] = (0,jotai__WEBPACK_IMPORTED_MODULE_3__/* .useAtom */ .KO)(_state__WEBPACK_IMPORTED_MODULE_2__/* .writeHistoryStateAtom */ .pf);
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>setLastState({
            title,
            href: asPath
        }), [
        asPath,
        setLastState,
        title
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useNavigationState);


/***/ }),

/***/ 38240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getPlayerName; }
/* harmony export */ });
const getPlayerName = (name, surnameType)=>{
    if (!name) return "Anonymous";
    const names = name === null || name === void 0 ? void 0 : name.split(" ");
    if (names.length === 1) return name;
    if (surnameType === "initial") return "".concat(names[0], " ").concat(names[names.length - 1][0].toUpperCase());
    return "".concat(names[0], " ").concat(names[names.length - 1]);
};


/***/ }),

/***/ 3277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ formatDateTime; }
/* harmony export */ });
/**
 * Formats dates in a human readable format.
 * @param date Date to be formatted
 * @param options Int.DateTimeFormatOptions
 */ const formatDateTime = function(date) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        dateStyle: "short",
        timeStyle: "short"
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
};


/***/ })

}]);